/* global intercom */
import React from 'react'

export default (props) => {
	if (props.user) {
		return (
			<div>
				<div className='capps-height-100' />
				<div id='intercom-support' className='capps-consciousapps-container' onTouchTap={() => {
					if (process.env.REACT_APP_ENV === 'ios' || process.env.REACT_APP_ENV === 'android') {
						intercom.displayMessenger()
					}
				}}>
					<div className='capps-consciousapps-text'>support by</div><div className='capps-consciousapps small'>conscious <span className='capps-consciousapps-bold'>apps</span></div>
				</div>
			</div>
		)
	}
	return null
}



// WEBPACK FOOTER //
// ./src/Components/Footer/ConsciousApps.js